<script setup lang="ts">
import { simulatorDefinitions } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'

/**
 * Bloque A de la seccion de simuladores: "que es un simulador".
 *
 * Se publica en dos piezas, porque ocupan lugares distintos de la seccion:
 *
 * - `part="head"`: el encabezado ("Que es" + titular + bajada) va a **ancho
 *   completo**, sobre el showcase, para que el titular no se parta en varias
 *   lineas dentro de una columna estrecha.
 * - `part="cards"`: las tres definiciones se apilan en vertical en la columna
 *   izquierda del showcase, junto al mockup de la pantalla de practica.
 */
const props = defineProps<{ part: 'head' | 'cards' }>()

const { registerReveal } = useLandingScroll()
</script>

<template>
  <div class="wl-sim-block wl-sim-block--whatis" :class="`wl-sim-whatis--${props.part}`">
    <div v-if="props.part === 'head'" class="wl-sim-block-head reveal" :ref="registerReveal">
      <span class="section-tag">Qué es</span>
      <h3 class="wl-sim-block-title">
        Un simulador es un <span class="gradient-text">examen de práctica</span> con el formato real
      </h3>
      <p class="wl-sim-block-desc">
        Trae el mismo temario, la misma estructura y el mismo tipo de preguntas que vas a presentar. Lo haces antes de
        la fecha real y te dice exactamente en qué áreas necesitas mejorar.
      </p>
    </div>

    <div v-else class="wl-sim-defs">
      <article
        v-for="(definition, index) in simulatorDefinitions"
        :key="definition.title"
        class="wl-sim-def reveal"
        :class="`reveal-d${index + 1}`"
        :ref="registerReveal"
      >
        <span class="wl-sim-icon">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path v-for="(path, i) in definition.icon.split('|')" :key="i" :d="path" />
          </svg>
        </span>
        <h4>{{ definition.title }}</h4>
        <p>{{ definition.description }}</p>
      </article>
    </div>
  </div>
</template>
